<template>
	<!-- Shape of pages/products.vue: page header, then a dense product grid. -->
	<div aria-hidden="true">
		<PageHeaderSkeleton />

		<div class="w-full flex flex-col items-center justify-start p-4 md:px-8 pt-8 md:pt-16">
			<div class="w-full max-w-7xl">
				<div class="grid gap-x-6 gap-y-8 grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
					<div v-for="n in 10" :key="n" class="w-full">
						<Skeleton rounded="rounded" class="w-full h-32 sm:h-48" />
						<Skeleton class="h-3.5 w-3/4 mx-auto mt-3" />
						<Skeleton class="h-3 w-1/2 mx-auto mt-2" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from '../skeleton.vue'
import PageHeaderSkeleton from './page-header-skeleton.vue'

export default {
	name: 'ProductsSkeleton',
	components: { Skeleton, PageHeaderSkeleton },
}
</script>
